angular.module 'zc.commonApi'

.factory 'Report', ($q, FacadeV2, Project) ->

  class Report
    @find: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/report_stats/#{paths.dimension}/find",
        params: params
      .then (res) ->
        res.data

    @findOne: (paths, params) ->
      FacadeV2.request "/apikeys/#{paths.apikey}/report_stats/#{paths.dimension}/find_one",
        params: params
      .then (res) ->
        res.data



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/report_service.js.coffee